/** Coerce API payloads that sometimes return T or T[]. */
export function normalizeToList<T>(data: T[] | T | undefined | null): T[] {
  if (data == null) return [];
  if (Array.isArray(data)) return data;

  return [data];
}
